import { Component, OnInit, ViewChild } from '@angular/core';
import { AmChartsService } from '@amcharts/amcharts3-angular';
import { ExportExcelService } from 'app/service/export-excel.service';
import { Router } from '@angular/router';
import { CpmService } from 'app/service/cpm.service';
import { WatchListComponent } from '../watch-list/watch-list.component';
import { environment } from '../../../environments/environment';
@Component({
  selector: 'app-market-level-watch-list',
  templateUrl: './market-level-watch-list.component.html',
  styleUrls: ['./market-level-watch-list.component.scss']
})
export class MarketLevelWatchListComponent implements OnInit {
  @ViewChild(WatchListComponent) marketWatchList: WatchListComponent;

  constructor(
    private router: Router,
    private cpmService: CpmService,
    private excelService: ExportExcelService
  ) { }

  ngOnInit() { }

  exportFunctionsWatchList() {
    const arrayOfFunctions: Map<String, Function> = new Map<String, Function>();
    arrayOfFunctions.set(
      'email',
      this.exportEmailWatchList(
        this.marketWatchList.currentItem,
        this.cpmService
      )
    );
    arrayOfFunctions.set(
      'print',
      this.exportPrintWatchList(this.marketWatchList.currentItem)
    );
    arrayOfFunctions.set(
      'pdf',
      this.exportPdfWatchList(this.marketWatchList.currentItem)
    );

    arrayOfFunctions.set(
      'excel',
      this.exportExcelWatchList(
        this.excelService,
        this.marketWatchList
      )
    );
    return arrayOfFunctions;
  }

  exportEmailWatchList = function (currentItem, service) {
    return function mailWatchList() {
      service.saveMarketWatchListPdfFile(currentItem).then(filename => {
        const subject = 'Watch List';
        const downloadUrl = encodeURIComponent(
          `${environment.cpmBaseUrl}/download?type=report&filename=${filename}`
        );
        window.location.href = `mailto:?subject=${subject}&body=${downloadUrl}`;
      });
    };
  };

  exportPrintWatchList = function (currentItem) {
    return function watchlistPrint() {
      const popupWin = window.open(
        `/#/marketWatchList/${currentItem}`,
        '_blank',
        'width=850px,height=1024px'
      );
    };
  };

  exportPdfWatchList = function (currentItem) {
    const service = this.cpmService;
    return function watchlistPdf() {
      service.downloadFile(
        `${environment.cpmBaseUrl}/pdf/marketWatchList?sort=${currentItem}`
      );
    };
  };

  exportExcelWatchList(
    service,
    marketWatchList
  ) {
    return function excelMarketPerformances() {
      marketWatchList.currentItem === 'comp'
        ? service.exportExcelByCompany(marketWatchList.listByCompany, 'Market Company')
        : service.exportMarketLevelWatchList(
          marketWatchList.dataTable,
          marketWatchList.marketWlType,
          marketWatchList.nameTicker,
          'Market Level Watch List'
        );
    };
  }

}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/market-level/market-level-watch-list/market-level-watch-list.component.ts